/*
 * @Author: gaobin
 * @Date: 2025-05-22 19:36:21
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-31 16:14:24
 * @Description: 自定义埋点
 */
import store from '@/store';

/** 上报埋点 */
class MyTracker {
  /** 上报数据到服务端 */
  report(eventParams) {
    const params = [...eventParams];
    console.log('tracker log=> report', params);
    store.dispatch('SendTracker', params);
  }
}

export const sendTracker = new MyTracker();
